import { _G } from '@/utils/_common';
import moment from 'moment-timezone';


export const G = Object.assign(_G, {
    ajaxBaseUrl: {
        // "default": `http://127.0.0.1:8000`,
        "default": `https://backend.icki.az`,
    },

    ajaxHeaders: {
        'X-Reguest-With': () => {
            // return '__IOQwfn2983LKasjnflKJnalnlkwebl__';
            return btoa(_G.exf9(moment.utc().valueOf()) + '.' + _G.exf9('__IOQwfn2983LKasjnflKJnalnlkwebl__'));
        },
    },

    // mediaURL: `http://127.0.0.1:8000/`,

    main_host: 'icki.az',

    defaultSelectedMenu: "home",

    defaultPage: "pages/Home",

    projectName: "Icki.az",
    projectSubtitle: "ICKI",
    projectInfo: `ICKI.AZ haqqinda`,

    footerPowered: 'Powered by <a href="https://diarc.az" class="footer-info-link mx-1" target="_blank">diarc.az</a> © 2024',
    footerDescription: 'icki.az',

    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 15, 25, 50, 100],

    // uploadedFileSize: 52428800,
    uploadedFileSize: 10485760, // 10 Mb

    showFilterAfterLength: 15,

    toastLifeTime: 2000,

    ignored_routes: [
        "pdf_viewer_letter",
        "pdf_viewer",
    ],

});
